import * as React from "react";

import { User } from "../../userTypes";
import ManualVerificationThirdPartyVerification from "./ManualVerificationThirdPartyVerification";
import ManualVerificationTable from "./ManualVerificationTable";
import ManualVerificationButtonsContainer from "./ManualVerificationButtonsContainer";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
};

export default class Verification extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  // What is onUserChanged and why is it everywhere. When is it actually necessary?

  render() {
    const { user } = this.props;

    return (
      <section className="padded">
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            marginTop: "50px",
          }}
        >
          <span>Manual verification</span>
        </h3>

        <ManualVerificationTable user={user} />

        <ManualVerificationButtonsContainer
          user={user}
          onUserChanged={this.props.onUserChanged}
        />

        <ManualVerificationThirdPartyVerification
          user={user}
          onUserChanged={this.props.onUserChanged}
        />
      </section>
    );
  }
}
